/**
 * Designed by OnHOW YouTube Channel - Anas El Medlaoui
 * Ajustes por duplicación de descripción, estilo y reemplazo de ícono por "+"
 */

const onhowStyles = `
  /* Contenedor general */
  .onhow-accordion {
    /* nada especial aquí; solo dejamos el scope limpio */
  }

  /* Cada fila (details) con divisor sutil */
  .onhow-accordion details {
    border-bottom: 1px solid rgba(0,0,0,0.12);
  }
  /* Línea superior opcional para el primer item (descomenta si la quieres) */
  /* .onhow-accordion details:first-child { border-top: 1px solid rgba(0,0,0,0.12); } */

  /* Layout del summary (cabecera clickeable) con padding vertical ligero */
  .onhow-accordion summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0; /* padding arriba y abajo */
    cursor: pointer;
    list-style: none; /* Safari */
  }
  .onhow-accordion summary::-webkit-details-marker {
    display: none; /* Oculta el marcador nativo */
  }

  .onhow-accordion .summary__title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
  }

  /* Títulos */
  .onhow-accordion .accordion__title {
    font-size: calc(var(--font-heading-scale) * 1.13em);
    margin: 0;
  }

  /* Contenido con padding inferior/superior ligero */
  .onhow-accordion .accordion__content {
    padding: 8px 0 12px; /* arriba 8px, abajo 12px */
  }

  /* Ícono PLUS hecho con pseudo-elementos (reemplaza al caret) */
  .onhow-accordion .onhow-plus {
    position: relative;
    width: 14px;
    height: 14px;
    flex: 0 0 auto;
    display: inline-block;
    margin-left: 12px;
  }
  .onhow-accordion .onhow-plus::before,
  .onhow-accordion .onhow-plus::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    background: currentColor;
    transform: translate(-50%, -50%);
    transition: opacity 200ms ease, transform 200ms ease;
  }
  /* barra horizontal */
  .onhow-accordion .onhow-plus::before {
    width: 14px;
    height: 2px;
    border-radius: 1px;
  }
  /* barra vertical (que desaparece al abrir para parecer "–") */
  .onhow-accordion .onhow-plus::after {
    width: 2px;
    height: 14px;
    border-radius: 1px;
  }
  /* Al abrir: queda "menos" (ocultamos la barra vertical) */
  .onhow-accordion details[open] summary .onhow-plus::after {
    opacity: 0;
    transform: translate(-50%, -50%) scaleY(0.6);
  }

  /* Animación de contenido abierto */
  .onhow-accordion details[open] .accordion__content {
    animation: slowReveal 400ms ease-in-out;
  }
  @keyframes slowReveal {
    0% { opacity: 0; transform: translateY(-8px); }
    100% { opacity: 1; transform: translateY(0); }
  }

  /* Oculta duplicados marcados por el script */
  .product__description.rte[data-onhow-hidden="true"] { display: none !important; }
`;

function addStyles(stylesText) {
  if (document.getElementById('onhow-desc-styles')) return;
  const styleElement = document.createElement('style');
  styleElement.id = 'onhow-desc-styles';
  styleElement.textContent = stylesText;
  document.head.appendChild(styleElement);
}

/**
 * Elige el mejor contenedor de descripción:
 * 1) Que tenga <h3> (para construir acordeón por secciones)
 * 2) Si ninguno tiene <h3>, el de mayor longitud de texto
 * 3) Excluye los que ya estén procesados o dentro de acordeones previos
 */
function pickBestDescriptionContainer() {
  const all = Array.from(document.querySelectorAll('.product__description.rte'));
  if (!all.length) return null;

  // Filtra candidatos válidos (sin procesar y no ya dentro de nuestro acordeón)
  const candidates = all.filter(el => {
    if (el.dataset.onhowProcessed === 'true') return false;
    if (el.closest('.onhow-accordion')) return false;
    return true;
  });

  if (!candidates.length) return null;

  const withH3 = candidates.filter(el => el.querySelector('h3'));
  if (withH3.length) return withH3[0]; // el primero con h3

  // Si ninguno tiene h3, toma el de mayor contenido (más probable que sea la descripción principal)
  return candidates.sort((a, b) => (b.textContent || '').length - (a.textContent || '').length)[0];
}

/**
 * Oculta/elimina duplicados de descripción que no sean el contenedor activo.
 * Usa un enfoque seguro: primero intenta ocultar, si el tema vuelve a inyectar, re-ocultamos.
 */
function hideOtherDescriptions(keepEl) {
  const all = Array.from(document.querySelectorAll('.product__description.rte'));
  all.forEach(el => {
    if (el === keepEl) return;
    if (keepEl.contains(el)) return;
    el.setAttribute('data-onhow-hidden', 'true');
    el.style.display = 'none';
  });
}

class OnhowDescriptionAccordion {
  constructor() {
    // Si ya hay un acordeón nuestro en la página y está poblado, no hacer nada
    if (document.querySelector('.onhow-accordion')) return;

    this.descriptionContainer = pickBestDescriptionContainer();
    if (!this.descriptionContainer) return;

    // Marca para evitar doble procesamiento en recargas parciales/JS de tema
    this.descriptionContainer.dataset.onhowProcessed = 'true';

    addStyles(onhowStyles);
    this.init();

    // Dedupe tras construir
    hideOtherDescriptions(this.descriptionContainer);

    // Observa mutaciones que reinyecten descripciones y vuelve a ocultarlas
    this.observeForDuplicates();
  }

  init() {
    // Guarda original por si necesitas restaurar (opcional)
    this.originalContent = this.descriptionContainer.innerHTML;

    const h3Elements = this.descriptionContainer.querySelectorAll('h3');
    if (h3Elements.length > 0) {
      this.createAccordion(h3Elements);
    } else {
      // Si no hay h3, convertimos todo en un solo item de acordeón
      this.createSingleAccordion();
    }
  }

  createAccordion(h3Elements) {
    const accordionContainer = document.createElement('div');
    accordionContainer.className = 'onhow-accordion product__accordion accordion quick-add-hidden';

    h3Elements.forEach((h3Element, index) => {
      let contentElements = [];
      let currentElement = h3Element.nextElementSibling;

      // Recoge todo hasta el próximo H3
      while (currentElement && currentElement.tagName !== 'H3') {
        contentElements.push(currentElement.cloneNode(true));
        currentElement = currentElement.nextElementSibling;
      }

      const details = document.createElement('details');
      details.id = `Details-onhow-${index}`;
      if (index === 0) details.setAttribute('open', '');

      const summary = document.createElement('summary');
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');
      summary.setAttribute('aria-controls', `ProductAccordion-onhow-${index}`);

      const summaryTitle = document.createElement('div');
      summaryTitle.className = 'summary__title';

      const heading = document.createElement('h2');
      heading.className = 'h4 accordion__title';
      heading.textContent = h3Element.textContent;

      /* Reemplazamos el caret por el ícono "+" */
      const iconContainer = document.createElement('span');
      iconContainer.className = 'onhow-plus';
      iconContainer.setAttribute('aria-hidden', 'true');

      const content = document.createElement('div');
      content.className = 'accordion__content rte';
      content.id = `ProductAccordion-onhow-${index}`;

      contentElements.forEach(element => content.appendChild(element));

      summaryTitle.appendChild(heading);
      summary.appendChild(summaryTitle);
      summary.appendChild(iconContainer);
      details.appendChild(summary);
      details.appendChild(content);
      accordionContainer.appendChild(details);
    });

    // Reemplaza TODO el contenido del contenedor seleccionado por nuestro acordeón
    this.descriptionContainer.innerHTML = '';
    this.descriptionContainer.appendChild(accordionContainer);

    this.initializeAccordion();
  }

  createSingleAccordion() {
    const accordionContainer = document.createElement('div');
    accordionContainer.className = 'onhow-accordion product__accordion accordion quick-add-hidden';

    const details = document.createElement('details');
    details.id = 'Details-onhow-0';
    details.setAttribute('open', '');

    const summary = document.createElement('summary');
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'true');
    summary.setAttribute('aria-controls', 'ProductAccordion-onhow-0');

    const summaryTitle = document.createElement('div');
    summaryTitle.className = 'summary__title';

    const heading = document.createElement('h2');
    heading.className = 'h4 accordion__title';
    heading.textContent = 'Descripción';

    /* Ícono "+" en modo single */
    const iconContainer = document.createElement('span');
    iconContainer.className = 'onhow-plus';
    iconContainer.setAttribute('aria-hidden', 'true');

    const content = document.createElement('div');
    content.className = 'accordion__content rte';
    content.id = 'ProductAccordion-onhow-0';

    // Usa el HTML original completo como un único panel
    content.innerHTML = this.originalContent || '';

    summaryTitle.appendChild(heading);
    summary.appendChild(summaryTitle);
    summary.appendChild(iconContainer);
    details.appendChild(summary);
    details.appendChild(content);
    accordionContainer.appendChild(details);

    this.descriptionContainer.innerHTML = '';
    this.descriptionContainer.appendChild(accordionContainer);

    this.initializeAccordion();
  }

  initializeAccordion() {
    const detailsElements = this.descriptionContainer.querySelectorAll('details');

    detailsElements.forEach(details => {
      const summary = details.querySelector('summary');
      summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !details.hasAttribute('open'));
      });

      details.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', 'false');
        summaryElement.focus();
      });
    });
  }

  observeForDuplicates() {
    // Observa el body porque algunos temas reinyectan bloques al cambiar variantes
    const obs = new MutationObserver(() => {
      // Vuelve a ocultar duplicados si reaparecen
      hideOtherDescriptions(this.descriptionContainer);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  restoreOriginalDescription() {
    if (this.originalContent) {
      this.descriptionContainer.innerHTML = this.originalContent;
      this.descriptionContainer.dataset.onhowProcessed = 'false';
    }
  }
}

(function() {
  function initAccordion() {
    // Evita doble init si ya procesamos alguno
    if (document.querySelector('.product__description.rte[data-onhow-processed="true"]')) return;
    const container = pickBestDescriptionContainer();
    if (!container) return;

    // Importante: crea la instancia usando el contenedor elegido
    new OnhowDescriptionAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }
})();
